// Mounts interactive "islands" into the server-rendered modern shell (ADR 0003).
// A ported view drops a mount point next to the form field it enhances:
//
//   <div data-island="rich-text" data-props="<%= { inputId: "…" }.to_json %>"></div>
//
// This entrypoint is loaded once in layouts/modern.html.erb; it scans for those
// mount points, looks the name up in the registry, and mounts the matching
// island. Islands are lazily imported so a page only pays for what it renders.
import { islandLoaders } from '~/islands/registry'

function parseProps(node) {
  const raw = node.dataset.props
  if (!raw) return {}
  try {
    return JSON.parse(raw)
  } catch (error) {
    console.error('[islands] invalid data-props on', node, error)
    return {}
  }
}

// Mount every not-yet-mounted island under `root`. Idempotent: the
// `data-island-mounted` guard means a re-scan (e.g. after a partial swap) never
// double-mounts an existing island.
export async function mountIslands(root = document) {
  const nodes = root.querySelectorAll('[data-island]:not([data-island-mounted])')
  await Promise.all(
    [...nodes].map(async (node) => {
      const loader = islandLoaders[node.dataset.island]
      if (!loader) return
      node.dataset.islandMounted = 'true'
      try {
        const module = await loader()
        module.mount(node, parseProps(node))
      } catch (error) {
        console.error(`[islands] "${node.dataset.island}" failed to mount`, error)
      }
    }),
  )
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => mountIslands())
} else {
  mountIslands()
}
